<div id="settings-office-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH OFFICES -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <div class="row no-gutters mb-3">
                        <button id="office_management.btn.create_office"
                                mat-flat-button
                                color="accent"
                                class="full-width"
                                (click)="createOffice()">
                            {{ 'office_management.btn.create' | translate | uppercase }}
                        </button>
                    </div>

                    <action-list *ngIf="officeList"
                                 [items]="officeList.items"
                                 [options]="actionListOptions"
                                 [selected]="selectedOffice"
                                 [identifier]="'id'"
                                 (select)="selectOffice($event)"
                                 (delete)="deleteOffice($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH SELECTED USER -->


        <div class="col-sm-12 col-md-8">

            <mat-card>

                <mat-card-content>

                    <div class="row">
                        <mat-chip-list class="pl-3 mb-4">
                            <mat-chip color="primary"
                                      selected
                                      *ngIf="selectedOffice && selectedOffice.member_structure">
                                {{ 'office_management.lbl.office_assigned_to' | translate }} {{ selectedOffice.member_structure.display_name }}
                            </mat-chip>
                        </mat-chip-list>
                    </div>

                    <smp-office *ngIf="selectedOffice"
                                [idPrefix]="'office_management.'"
                                [client]="client"
                                [bananaBox]="selectedOffice"
                                (bananaBoxChange)="updateInList($event)"
                                (canceled)="cancelEdit()">
                    </smp-office>
                </mat-card-content>

            </mat-card>

        </div>

    </div>

</div>
